import type React from "react";
import AppProviders from "@/app/AppProviders";
import AppRouter from "@/app/router";

function App(): React.JSX.Element {
	return (
		<AppProviders>
			<AppRouter />
		</AppProviders>
	);
}

export default App;
